import { render, staticRenderFns } from "./questionnaireDataStatistics.vue?vue&type=template&id=9a087f7c"
import script from "./questionnaireDataStatistics.vue?vue&type=script&lang=js"
export * from "./questionnaireDataStatistics.vue?vue&type=script&lang=js"
import style0 from "./questionnaireDataStatistics.vue?vue&type=style&index=0&id=9a087f7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports